import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import LandingPage from './components/LandingPage';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import VerifyEmail from './components/auth/VerifyEmail';
import Dashboard from './components/Dashboard';
import CreateSalon from './components/salon/CreateSalon';
import SalonDashboard from './components/salon/SalonDashboard';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import Pricing from './components/Pricing';
import PublicCatalogue from './components/PublicCatalogue';
import PublicDressPage from './components/PublicDressPage';
import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Home Route - shows landing page if not authenticated, dashboard if authenticated
const HomeRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  
  return isAuthenticated ? <Navigate to="/dashboard" /> : <LandingPage />;
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/create-salon" element={
                <ProtectedRoute>
                  <CreateSalon />
                </ProtectedRoute>
              } />
              <Route path="/salon/:salonId" element={
                <ProtectedRoute>
                  <SalonDashboard />
                </ProtectedRoute>
              } />
              <Route path="/salon/:salonId/:section" element={
                <ProtectedRoute>
                  <SalonDashboard />
                </ProtectedRoute>
              } />
              <Route path="/salon/:salonId/:section/:page" element={
                <ProtectedRoute>
                  <SalonDashboard />
                </ProtectedRoute>
              } />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/" element={<HomeRoute />} />
              <Route path="/shops/:salonSlug" element={<PublicCatalogue />} />
              <Route path="/shops/:salonSlug/dress/:dressId" element={<PublicDressPage />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;